// extracted by mini-css-extract-plugin
export default {"sib-loader":"ZxsW1092Hd9x7WHIbwBw","indicator-spin":"kNrjqXFIoCJsx9bsNsHd","sib-loader--absolute":"NOvqZ5W5X1LL8dqROpue"};